import React from 'react';
import './term-of-use.css';

const TermsOfUse = () => {
  return (
    <div className="terms-container">
      <header className="terms-header">
        <h1>Terms of Use</h1>
        <p>E-Techno Educational and Research Society</p>
      </header>

      <section className="terms-section">
        <h2>1. Purpose of Donations</h2>
        <p>
          All donations will be used to support our programs, projects, and operational needs in line with our mission to promote education and research.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. Voluntary Contributions</h2>
        <p>
          All donations are voluntary. Donors are encouraged to review the details of their contributions before proceeding.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. No Refunds</h2>
        <p>
          Donations are final and non-refundable. Please review our No Refund Policy for more details.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. Acknowledgment</h2>
        <p>
          We may acknowledge donors through our website, reports, or events. If you prefer to remain anonymous, please notify us at the time of donation.
        </p>
      </section>

      <section className="terms-section">
        <h2>5. Contact Us</h2>
        <p>
          For inquiries or assistance regarding donations, please contact us at: <br />
          Email: <a href="mailto:contact@etechnoedu.org">contact@etechnoedu.org</a>
        </p>
      </section>

      <footer className="terms-footer">
        <p>&copy; 2024 E-Techno Educational and Research Society. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default TermsOfUse;
